import { TableColumnsType } from 'antd';
import dayjs from '/react4xp/mixins/dayjsConfig';
import { localize } from '/react4xp/mixins/helpers';

export const columns = (translations: Record<string, string>): TableColumnsType => [
    {
        title: '№',
        key: 'index',
        width: 85,
        align: 'center',
        render: (_: any, __: any, index: number) => index + 1,
    },
    {
        title: localize('find-liquidated-full-name', translations),
        dataIndex: 'nameOrFio',
        key: 'nameOrFio',
    },
    {
        title: localize('find-liquidated-iin-bin-rnn', translations),
        dataIndex: 'iinBin',
        key: 'iinBin',
        width: 140,
    },
    {
        title: localize('find-liquidated-begin-date', translations),
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (a) => dayjs(a).format('DD.MM.YYYY'),
        width: 130,
    },
];
